// extracted by mini-css-extract-plugin
module.exports = {"WEIGHT":"400","PATH":"/app/themes/strazzanti/dist/font/crimsontext-regular.62f10d46561ed0b911d4.ttf","NAME":"Crimson Text","STYLE":"normal"};